import { pipe, prop } from 'ramda';
import { selectAllMeState } from 'src/common/state/me/me-selectors';

export const selectFlags = pipe(selectAllMeState, prop('flags'));

export type PaymentCollectionType = 'card-element' | 'payment-element';
export const selectPaymentCollectionType = pipe(
  selectFlags,
  (flags): PaymentCollectionType =>
    (flags['payment-collection-type'] as PaymentCollectionType) ||
    'card-element'
);
